/*=========================================================================================
  File Name: moduleMapMutations.js
  Description: Map Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	CLOSE_MAP_SIDEBAR(state) {
		state.toggleMapSidebar = false;
	},
	OPEN_MAP_SIDEBAR(state) {
		state.toggleMapSidebar = true;
	},
	TOGGLE_MAP_SIDEBAR(state, val) {
		state.toggleMapSidebar = val;
	},
	OPEN_STREETVIEW(state, val) {
		state.popupStreeViewActive = val;
	},
	CHANGE_MAP_STYLE(state, mapStyleName) {
		state.mapStyle = mapStyleName;
	},
	CHANGE_TRAFFIC_LAYER(state, val) {
		state.activeTrafficLayer = val;
	},
	SAVE_OPTIONS_PROGRAMED_ROUTE(state, options) {
		Object.assign(state.optionsProgramedRoute, options);
	},
	SAVE_OPTIONS_EXECUTED_ROUTE(state, options) {
		Object.assign(state.optionsExecutedRoute, options);
	},
	TOGGLE_GEO(state, val) {
		state.toggleGeorreferencer = val;
	},
	TOGGLE_ROUTES_LEGENDS(state, val) {
		state.toggleRoutesLegends = val;
	},
	RESOURCES_ROUTES_LEGENDS(state, val) {
		state.resourceRoutesLegends = val;
	},
	SET_EXECUTE_ROUTE(state, val) {
		state.executedRoutes = val;
	},
	SET_ROUTE_TYPE(state, val) {
		state.routeType = val;
	},
	SET_MODULE_TYPE(state, val) {
		state.module = val;
	},
	SET_MAP_COLOR(state, val) {
		if (!state.colorMap.has(val.resourceId)) {
			state.colorMap.set(val.resourceId, val.color);
		}
	},
	CLEAR_MAP_COLOR(state) {
		if (state.colorMap.size > 0) {
			state.colorMap.clear();
		}
	},
	SET_ZONE_GEOCERCA(state, val) {
		state.zoneList.push(val);
	},
	CLEAR_ZONE_GEOCERCA(state) {
		state.zoneList = [];
	},
	LOCATE_PANIC_ALARM(state, notification) {
		state.locatePanicAlarm.trigger += 1;
		state.locatePanicAlarm.notification = notification;
	},
};
